import { arrayValue } from '../array.js';
import type { ToolRegistryCurrentPointer } from '../../types/tool-registry.js';

function canonicalize(value: unknown): unknown {
    const entries = arrayValue(value);
    if (entries !== null) {
        return entries.map(canonicalize);
    }
    if (value !== null && typeof value === 'object') {
        const entries: [string, unknown][] = Object.entries(value);
        return Object.fromEntries(entries
            .sort(([left], [right]) => (left < right ? -1 : left > right ? 1 : 0))
            .map(([key, child]) => [key, canonicalize(child)]));
    }
    return value;
}

export function canonicalRegistryJson(value: unknown): string {
    return `${JSON.stringify(canonicalize(value), null, 2)}\n`;
}

export function canonicalUnsignedToolRegistryPointer(pointer: ToolRegistryCurrentPointer): string {
    return canonicalRegistryJson({
        apiVersion: pointer.apiVersion,
        releaseId: pointer.releaseId,
        activatedAt: pointer.activatedAt,
        expiresAt: pointer.expiresAt,
        sequence: pointer.sequence,
        tools: pointer.tools,
    });
}
